import { useTheme } from "@emotion/react"
import React, { useEffect, useState } from "react"
import { useHistory, useLocation, useParams } from "react-router"
import Button from "../../components/Button"
import InputField from "../../components/InputField"
import {
  getAllCategories,
  getAllConsultantReferralDetails,
  getAllStaffs,
  getPatientDetail,
  getSubCategoryByCategory,
  sendOtpToVerifyNumber,
  uploadSpecificFile,
  VerifyOtp,
} from "../../core/services/api"
import { styles } from "../../resources/styles/Styles"
import { HistoryViewStyles } from "../../resources/styles/pages/HistoryViewStyles"
// import "./Addpatient.scss"
import Box from "@mui/material/Box"
import moment from "moment"
import Modal from "react-bootstrap/Modal"
import { useSelector } from "react-redux"
import Toast from "../../components/Toast"
import {
  bloodOptions,
  cghsOption,
  countryOptions,
  educationLevelOptions,
  ethnicityOptions,
  genderOptions,
  insuranceOptions,
  languageOptions,
  maritalStatusOptions,
  occupationOptions,
  patientTag,
  psuOptions,
  referredByOptions,
  salutationOptions,
  stateOptionsValues,
  trustOptions,
  websitesOptions,
} from "./DropdownList"

import { getPatientHistory, getTemplatesByType } from "core/services/api/patientDiagnosisService"
import fileUtils from "fileUtils"
import SurveyComponent from "pages/RMO/components/cancerTemplate/Template"
import defaultSurveyConfig from "pages/RMO/components/cancerTemplateForm/template"
import Select from "react-select"
import { countriesList } from "../../core/jsons/countries"
import { MocUserRole } from "../../core/services/models/Enums"
import ToggleSwitch from "../ToggleSwitch"
import "./patientEditForm.scss"
import { calculateAge } from "core/utils/date"

const phoneNumberEditPermittedRoles = [
  MocUserRole.SYSTEM_ADMIN,
  MocUserRole.CENTER_ADMIN,
  MocUserRole.FRONT_DESK,
  MocUserRole.RMO,
  MocUserRole.CONSULTANT
]

function PatientEditForm({
  onSubmit,
  patientDetail,
  userRole,
  isEditable,
  userDetail,
  test,
  previousState
}: any) {
  const history = useHistory()
  const { patientId }: any = useParams()
  const queryParameters = new URLSearchParams(window?.location?.search)
  const isGeneralConsent = queryParameters?.get("isGeneralConsent")
  useEffect(() => {
    if (isGeneralConsent) {
      const element: any = document?.getElementById("general-consent-container")
      if (element) {
        element?.scrollIntoView({ behavior: "smooth" })
      }
    }
  }, [isGeneralConsent])

  const [patientInfo, setpatientInfo] = useState<any>({
    centers: [userDetail?.currentCenter],
    ageString: "Select Dob To Calculate Age.",
    isVIP: false,
    // countryCode: "+91",
  })

  const [formErrors, setFormErrors] = useState<any>({})
  const [isSubmit, setIsSubmit] = useState(false)
  const [open, setOpen] = useState<boolean>(false)
  const [surveyData, setSurveyData] = useState<any>()
  const [formSaved, setFormSaved] = useState<boolean>(false)
  const [generalConsentTemplate, setGeneralConsentTemplate] = useState<any>({})
  const [categories, setCategories] = useState<any>()
  const [isOtpVerifiedAdmin, toggleOtpVerifiedAdmin] = useState<any>(false)
  const [isOtpVerified, toggleOtpVerified] = useState<any>(false)
  const [isVerifyOtpPhone, setVerifyOtpPhone] = useState<boolean>()
  const [isVerifyOtpPhoneAdmin, setVerifyOtpPhoneAdmin] = useState<boolean>()
  const location = useLocation()
  const [checkOtp, setCheckOTP] = useState<any>()
  const [displayToast, toggleDisplayToast] = useState<any>()

  const centerID = location?.state?.centerId
  //Editable state
  const [isEditFlag, setIsEditFlag] = useState<boolean>(false)
  // @ts-ignore
  let readOnly = useSelector((state) => state?.user?.readOnly);

  //setIsEditFlag(readOnly);
  const [isEditedAlready, setIsEditedAlready] = useState<any>()
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false)

  //Referal Doctors
  const [referalConsultants, setReferalConsultants] = useState<any>([])
  const [referalConsultantsOptions, setReferalConsultantsOptions] = useState<any>([])

  useEffect(() => {
    let tempJson: any = {}
    getTemplatesByType("COMMON")
      .then((res: any) => {
        tempJson = res?.find((e: any) => e?.subType === "General Consent")?.data[0]?.json || {}
        setGeneralConsentTemplate(tempJson)
      })
      .catch((err: any) => console.log(err?.message))

    getAllConsultantReferralDetails(userDetail?.currentCenter?.centerId)
      .then((res: any) => {
        setReferalConsultants(res)
        const referalDoctorOptions = res?.map((ele: any) => {
          return { label: ele?.consultantName, value: ele?.id }
        })
        referalDoctorOptions?.push({ label: "Others", value: "Others" })
        setReferalConsultantsOptions(referalDoctorOptions)
      })
      .catch((err: any) => {
        console.log("err", err)
      })
  }, [])

  useEffect(() => {
    if (readOnly) {
      setIsEditFlag(true);
    }
    else {
      if (patientId && userRole === MocUserRole?.PATIENT && patientInfo?.isEditedAlready) {
        setIsEditFlag(true)
      } else {
        setIsEditFlag(false)
      }
    }
  }, [patientInfo])

  useEffect(() => {
    getAllCategories().then((res: any) => {
      // console.log("categories", res)
      const catArray = res.map((ele: any) => {
        return { label: ele?.replace("_", " "), value: ele }
      })

      setCategories(catArray)
    })
  }, [])

  useEffect(() => {
    if (patientInfo?.category) {
      handleCategory(patientInfo?.category?.toUpperCase())
    }
  }, [patientInfo?.category])

  useEffect(() => {
    if (userRole === MocUserRole.PATIENT && patientInfo?.isEditedAlready === false) {
      setIsEditedAlready(false)
    }

  })

  const handleFormComplete = (data: any) => {
    setSurveyData(data)
    setOpen(false)
    setFormSaved(true)
  }

  const handleSubmit = (e: any) => {
    e.preventDefault()
    scroll()
    setFormErrors(validate(patientInfo))
    setIsSubmit(true)
    // setPrintPatientInfo(patientInfo)
  }

  const [consultantDetails, setallConsultantDetails] = useState<any>([])
  const [displayConsultants, setDisplayConsultant] = useState<any>()

  useEffect(() => {
    // getAllConsultants(`?centerId=${userDetail?.currentCenter?.centerId}`)
    //   .then((res) => {
    //     console.log(res, "res1")
    //     setallConsultantDetails(res)

    //   })
    //   .catch((error) => {
    //     console.log("err", error)
    //   })


    let url = "";
    if (userDetail?.currentRole == "SYSTEM_ADMIN") {
      url = `?primaryRole=CONSULTANT`
    }
    else {
      url = `?primaryRole=CONSULTANT&centerId=${userDetail?.currentCenter?.centerId}`
    }
    console.log(userDetail, "user Detail in Patient Edit form");
    getAllStaffs(url).then((res: any) => {
      setallConsultantDetails(res)
    }).catch((err: any) => {
      console.log(err, "error");
    })
  }, [])

  useEffect(() => {
    scroll()

  }, [isSubmit, formErrors])



  const validate = (values: any) => {
    const errors: any = {}
    // const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i
    const regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    // drpodown validation
    if (!values?.title) {
      errors.title = "Title is required!"
    }
    if (!values?.gender) {
      errors.gender = "Gender is required!"
    }
    // input field validation
    if (!values?.firstName) {
      errors.firstName = "Patient First Name is required!"
    } else if (values?.firstName?.length < 3) {
      errors.firstName =
        "First Name should be equal or greater  than 3 characters"
    }
    if ((values?.pincode?.length < 6 && !(values?.pincode?.length === 0)) || values?.pincode?.length > 6) {
      errors.pincode = "Pincode must be of 6 digits"
    }
    if (!values?.category) {
      errors.category = "Category is required!"
    } else if (values?.category !== null && subcategories?.length === 0) {
      errors.category = "Please select different category"
    }

    if (!values?.dob) {
      errors.dob = "Patient Dob is required!";
    } else {
      const today = new Date();
      const checkDob =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1).toString().padStart(2, '0') +
        "-" +
        today.getDate().toString().padStart(2, '0');
      const x = new Date(values?.dob);
      const val =
        x.getFullYear() +
        "-" +
        (x.getMonth() + 1).toString().padStart(2, '0') +
        "-" +
        x.getDate().toString().padStart(2, '0');

      // Check if the year is not selected in the date field
      if (isNaN(x.getFullYear()) || values?.dob.length < 10) {
        errors.dob = "Please select a valid date with a year!";
      } else if (val > checkDob) {
        errors.dob = "Dob date cannot be greater than today's date!";
      } else if (values?.age > 200) {
        errors.dob = "Please select a valid Dob, age exceeds 200 years"
      }
    }

    if (values?.additionalDetails?.anniversaryDetails) {
      const x = new Date(values?.dob)
      const y = new Date(values?.additionalDetails?.anniversaryDetails)
      if (y <= x) {
        errors.anniversaryDetails =
          "Anniversary date should be greater than dob"
      }
    }
    if (!values?.countryCode) {
      errors.countryCode = "Country code is required!"
    }
    if (!values?.phoneNumber) {
      errors.phoneNumber = "Phone number is required!"
    }
    // else if (!/^[0-9]{10}$/.test(values?.phoneNumber)) {
    //   errors.phoneNumber = "Please enter correct phone number"
    // }
    if (
      values?.alternatePhoneNumber &&
      !/^[0-9]{10}$/.test(values?.alternatePhoneNumber)
    ) {
      errors.alternatePhoneNumber = "Please enter correct phone number"
    }
    if (
      values?.phoneNumber === values?.alternatePhoneNumber &&
      values?.phoneNumber
    ) {
      errors.alternatePhoneNumber =
        "Alternate phone number can not be same as primary phone number"
    }
    if (
      values?.alternatePhoneNumber &&
      !/^[0-9]{10}$/.test(values?.alternatePhoneNumber)
    ) {
      errors.alternatePhoneNumber = "Please enter correct phone number"
    }
    if (values?.email && !regex.test(values?.email)) {
      errors.email = "This is not a valid email format!"
    }
    if (
      values?.responsiblePersonPhoneNumber &&
      (values?.responsiblePersonPhoneNumber === values?.phoneNumber)
    ) {
      errors.responsiblePersonPhoneNumber =
        "Responsible Person's Phone Number can not be same as  Primary PhoneNumber"
    }


    if (
      values?.alternatePhoneNumber &&
      (values?.responsiblePersonPhoneNumber === values?.alternatePhoneNumber)
    ) {
      errors.responsiblePersonPhoneNumber =
        "Responsible Person's Phone Number can not be same as  Alternate PhoneNumber"
    }

    if (values?.category && !values?.subCategory) {
      errors.subCategory =
        "Sub category is required!"
    }

    if (!values?.primaryConsultantName) {
      errors.primaryConsultantName = "Primary Consultant is required!"
    }
    // if (!values?.doctorSpeciality) {
    //   errors.doctorSpeciality = "Doctor Speciality is required!"
    // }

    // if (!values?.doctorContactNumber) {
    //   errors.doctorContactNumber = "Doctor Contact Number is required!"
    // }
    return errors
  }

  //State and cities
  const [updatedCityOptions, setupdatedCityOption] = useState<any>()
  const newState: string[] = Object.keys(stateOptionsValues)
  function newCityOption(option: any) {
    setupdatedCityOption(stateOptionsValues[option])
  }
  useEffect(() => {
    if (!formErrors || (Object.keys(formErrors)?.length === 0 && isSubmit)) {
      onSubmit(patientInfo, surveyData)
    }
  }, [formErrors, isSubmit])

  useEffect(() => {
    if (patientId) {

      if (patientDetail) {
        getPatientDetail(patientId)
          .then((res: any) => {
            const temp: any = { ...res }
            temp["ageString"] = calculateAge(res?.dob)
            let name = res?.name?.split(" ")
            let lastName = ""
            if (name?.length > 0) {
              name?.slice(1)?.forEach((each: any) => {
                if (each?.length) {
                  if (each[each?.length - 1] === " " || each?.includes(" ")) {
                    lastName += each
                  }
                  else {
                    lastName += " " + each
                  }
                }
              })
            }
            temp["firstName"] = name[0] ? name[0] : ""
            temp["lastName"] = lastName ? lastName : ""
            if (temp["category"] === "TRUST") {
              temp["category"] = "TRUST"
              temp["trustOptions"] = "MOCF"
            }
            if (temp["category"] === "SELF_PAYING") {
              temp["category"] = "Self_Paying"
            } else if (temp["category"] === "INSURANCE") {
              temp["category"] = "Insurance"
            }
            else if (temp["category"] === "CLINICAL_RESEARCH") {
              temp["category"] = "Clinical_Research"
            }
            else if (temp["category"] === "GOVERNMENT_SCHEMES") {
              temp["category"] = "Government_Schemes"
            }
            if (temp?.tags !== null) {
              let tagValue = temp?.tags?.map((item: any) => {
                return { label: item, value: item }
              })
              temp["tags"] = tagValue
            }
            const ref_ = temp["referredBy"]
            temp["referredBy"] = ref_
            if (temp && temp.referredBy && temp.referredBy.doctorName) {
              const isConsultantOthers = referalConsultants?.filter((each: any) => {
                return each && each.consultantName === temp.referredBy.doctorName;
              });
              if (!isConsultantOthers || isConsultantOthers.length <= 0) {
                if (!temp.referredBy.doctorNameOthers) {
                  temp.referredBy.doctorNameOthers = temp.referredBy.doctorName;
                }
                temp.referredBy.doctorName = "Others";
              }
            }

            setpatientInfo(temp)
            if (
              res?.generalConsent !== null &&
              Object.keys(res?.generalConsent)?.length > 0
            ) {
              setSurveyData(res?.generalConsent)
              //Logic to Make complete button disabled
              let tempJson: any = {}
              getTemplatesByType("COMMON")
                .then((res1: any) => {
                  tempJson = res1?.find((e: any) => e?.subType === "General Consent")?.data[0]?.json || {}
                  if (
                    Object.keys(res?.generalConsent)?.includes("name") &&
                    Object.keys(res?.generalConsent)?.includes("patientName") &&
                    Object.keys(res?.generalConsent)?.includes("signature")
                  ) {
                    tempJson["showNavigationButtons"] = "none"
                    tempJson["pages"][0]["readOnly"] = true
                  }
                  setGeneralConsentTemplate(tempJson)
                })
                .catch((err: any) => console.error(err?.message))
            } else {
              const temp: any = { ...surveyData }
              temp["patientName"] = res?.isVIP ? res?.mocId : res?.name
              temp["name"] = res?.isVIP ? res?.mocId : res?.name
              setSurveyData(temp)
            }
            setVerifyOtpPhone(true)
          })
          .catch((err) => {
            console.log("err", err)
          })
      }
    }
    else {
      setpatientInfo({
        centers: [userDetail?.currentCenter],
        ageString: "Select Dob To Calculate Age.",
        isVIP: false,
        // countryCode: "+91",
      })
    }
  }, [patientDetail, referalConsultants])



  const title = salutationOptions.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const genders = genderOptions.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const bloodgroups = bloodOptions.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const martialstatus = maritalStatusOptions.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const educationallevel = educationLevelOptions.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const ethinicity = ethnicityOptions.map((ele: any) => {
    return { label: ele, value: ele }
  })

  const tags = patientTag?.tags.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const occupationoption = occupationOptions.map((ele: any) => {
    return { label: ele, value: ele }
  })
  // const categories = categoryOptions.map((ele: any) => {
  //   return { label: ele?.replace("_", " "), value: ele }
  // })

  const cghs = cghsOption.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const insurances = insuranceOptions.map((ele: any) => {
    return { label: ele, value: ele }
  })

  const trusts = trustOptions.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const psu = psuOptions.map((ele: any) => {
    return { label: ele, value: ele }
  })

  const countries = countryOptions.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const referredby = referredByOptions.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const languages = languageOptions.map((ele: any) => {
    return { label: ele, value: ele }

  })
  const websites = websitesOptions.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const states = newState.map((ele: any) => {
    return { label: ele, value: ele }
  })

  function uploadDocument(file: any) {

    const invalidFile: any = !fileUtils.validateFileExtension(file?.name)
    if (invalidFile) {
      toggleDisplayToast({ text: "Uploaded file extension not allowed", type: "error" })
      return;
    }

    // upload file and get the url
    const formData = new FormData()
    formData.append("files", file)
    uploadSpecificFile(formData, false)
      .then((res) => {
        let temp = { name: file?.name, blobUrl: res[0] }
        setpatientInfo({
          ...patientInfo,
          governmentIdDocument: temp,
        })
        setFormErrors({ ...formErrors, ...{ governmentIdDocument: "" } })
      })
      .catch((err) => {
        const errCode = err?.response?.data?.code
        if (errCode === "MaxUploadSizeExceededException") {
          setFormErrors({
            ...formErrors,
            ...{ governmentIdDocument: "Upload valid ID Proof document" },
          })
          setpatientInfo({
            ...patientInfo,
            governmentIdDocument: "",
          })
        }
      })
  }

  function handleSubmitPhone(e: any) {
    e.stopPropagation()
    e.preventDefault()
    if (patientInfo?.phoneNumber)
      sendOtpToVerifyNumber(patientInfo?.phoneNumber)
        .then((res) => {
          toggleOtpVerified(true)
          toggleOtpVerifiedAdmin(true)
        })
        .catch((err) => {
          if (err) {
            toggleOtpVerified(false)
            toggleOtpVerifiedAdmin(false)
            toggleDisplayToast({
              text: err?.response?.data?.message,
              type: "error",
            })
          }
        })
  }

  function handleSubmitOtpAndPhone(e: any) {
    e.stopPropagation()
    e.preventDefault()
    if (patientInfo?.phoneNumber)
      VerifyOtp(patientInfo?.phoneNumber, checkOtp)
        .then((res) => {
          setVerifyOtpPhone(true)
          setVerifyOtpPhoneAdmin(true)
        })
        .catch((err) => {
          setVerifyOtpPhone(false)
          setVerifyOtpPhoneAdmin(false)

          toggleDisplayToast({
            text: err?.response?.data?.message,
            type: "error",
          })
        })
  }

  function scroll() {
    let title = Object.keys(formErrors)
    const temp = title.includes("title")
      ? "section1"
      : title.includes("firstName")
        ? "section1"
        : title.includes("gender")
          ? "section2"
          : title.includes("dob")
            ? "section2"
            : title.includes("phoneNumber")
              ? "section3"
              : title.includes("countryCode")
                ? "section3"
                : title.includes("category") || title.includes("subCategory")
                  ? "section4"
                  : title.includes("addressline1") ? "section5" : title.includes("referredby") ? "section6" : title.includes("responsiblePersonName") ? "section7" : title.includes("governmentIdNo") ? "section8" : title.includes("nationality") ? "section9" : title.includes("alternatePhoneNumber") ? "section10" : ""

    const element = document.getElementById(temp)
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
    }
  }

  const theme = useTheme()
  const globalStyles = styles(theme)
  const classes = HistoryViewStyles(theme)
  const [patientHistoryData, setPatientHistoryData] = useState([{}])

  useEffect(() => {
    if (patientId) {
      getPatientHistory(patientId)
        .then((res: any) => {
          const todayDate = moment(new Date()).format("YYYY-MM-DD")
          const past = res.data.filter((a: any) => a.scheduleDate !== todayDate)
          const current = res.data.filter((a: any) => a.scheduleDate === todayDate)
          setPatientHistoryData(past);

        })
        .catch((err: any) => console.log("err in get patient history", err))


    }
  }, [patientId])

  const [subcategories, setsubcategories] = useState<any>()

  function handleCategory(selectedCategory: any) {
    getSubCategoryByCategory(selectedCategory)
      .then((res) => {
        const temp = res?.map((each: any) => {
          return {
            label: each?.name,
            value: each?.name
          }
        })
        setsubcategories(temp);
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  function renderAccordionContentRow(component: any, data: any) {
    return (
      <div className="col-md-12 col-lg-12 m-0 p-0 row">
        <div className={`${globalStyles.relative}`}>
          <div className={classes.dividerLine} />
        </div>

        <div className={`${classes.accordionEachRow} col-md-12 col-lg-12 m-0 p-0 row`}>
          <div
            className={`${globalStyles.pl0} ${globalStyles.pr0} text-center ${classes.dividerSection}`}
          >
            <img
              alt="green circle"
              src={"../../../assets/images/switchGreenCircle.svg"}
            />
            {/* {
              data?.id === appointmentId ? (
                <img
                  alt="green circle"
                  src={"../../../assets/images/switchGreenCircle.svg"}
                />
              ) : (
                <img
                  alt="red circle"
                  src={"../../../assets/images/switchRedCircle.svg"}
                />
              )
            } */}
          </div>
          {/* <div className="col-md-1"></div> */}
          <div className={`col-md-10 col-lg-10 p-0 ${classes.btmBorder}`}>
            {component}
          </div>
        </div>
      </div>
    )
  }

  return (

    <div className="patient-wrapper" >
      <div className="add-patient-wrapper">
        {formSaved && (
          <Toast
            textMessage="Saved successfully"
            onCloseText={"Close"}
            onClose={() => {
              setFormSaved(false)
            }}
            type="success"
          ></Toast>
        )}
        {displayToast && (
          <Toast
            textMessage={displayToast?.text}
            onCloseText={"Close"}
            onClose={() => {
              toggleDisplayToast(false)
            }}
            type="error"
          ></Toast>
        )}
        <div className="col-md-12 col-lg-12">
          <div>
            <div className="add-patient-form">
              <div className="patient-row">
                <div className="mocId-header">Patient ID : {patientInfo?.mocId}</div>
              </div>
              <div className="patient-row" id="section1">
                <div className="col-md-2 col-lg-2">
                  <label htmlFor="" className="label">
                    * Title
                  </label>
                  {/* <Dropdown
                  selected={patientInfo?.title}
                  updateDropdown={(option: any) => {
                    setpatientInfo({ ...patientInfo, title: option })
                  }}
                  placeholder="Title"
                  options={salutationOptions}
                  errorMsg={formErrors?.title}
                /> */}

                  <Select
                    className="country-select"
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        border: "1px solid #ccd0e7",
                        borderRadius: "10px"
                      })
                    }}
                    options={title}
                    defaultValue={title}
                    onChange={(option: any) => {
                      setpatientInfo({ ...patientInfo, title: option?.value })
                    }}
                    placeholder="Title"
                    value={title.filter(
                      ({ label }: any) => label === patientInfo.title
                    )}
                    isDisabled={isEditFlag}
                  />
                  <span className="error">{formErrors?.title}</span>
                </div>

                <div className="col-md-4 col-lg-4">
                  <label htmlFor="" className="label">
                    * First Name
                  </label>
                  <InputField
                    handleChange={(e) => {
                      setpatientInfo({
                        ...patientInfo,

                        firstName: e.target.value,
                      })
                    }}
                    readOnly={
                      (userRole !== MocUserRole.PATIENT &&
                        patientInfo?.isVIP &&
                        patientId) ||
                      isEditFlag || isEditedAlready
                    }
                    value={
                      userRole !== MocUserRole.PATIENT &&
                        patientInfo?.isVIP &&
                        patientId
                        ? "*****"
                        : patientInfo?.firstName
                    }
                    placeholder={"First Name"}
                    errorMsg={formErrors?.firstName}
                  />
                </div>

                <div className="col-md-4 lt col-lg-4">
                  <label htmlFor="" className="label">
                    Last Name
                  </label>
                  <InputField
                    handleChange={(e) =>
                      setpatientInfo({
                        ...patientInfo,
                        lastName: e.target.value,
                      })
                    }
                    readOnly={
                      (userRole !== MocUserRole.PATIENT &&
                        patientInfo?.isVIP &&
                        patientId) ||
                      isEditFlag
                    }
                    value={
                      userRole !== MocUserRole.PATIENT &&
                        patientInfo?.isVIP &&
                        patientId
                        ? "*****"
                        : patientInfo?.lastName
                    }
                    placeholder={"Last Name"}
                    errorMsg={formErrors?.lastName}
                  />
                </div>
                {userRole !== MocUserRole.PATIENT && (
                  <div className="col-md-2 col-lg-2 mn">
                    <label htmlFor="" className="label">
                      Mask Name?
                    </label>
                    <div className="vip">
                      <ToggleSwitch
                        disabled={
                          isEditFlag === true ||
                          userRole === MocUserRole.PATIENT
                          // ||
                          // (userRole !== MocUserRole.PATIENT &&
                          //   patientInfo?.isVIP &&
                          //   patientId
                          // )
                        }
                        checked={patientInfo?.isVIP}
                        onChange={(e: any) =>
                          setpatientInfo({
                            ...patientInfo,
                            isVIP: e.target.checked,
                          })
                        }
                      />
                    </div>
                  </div>
                )}
              </div>

              <div className="patient-row" id="section2">
                <div className="col-md-3 col-lg-3">
                  <label htmlFor="" className="label">
                    * Gender
                  </label>
                  {/* <Dropdown
                  selected={patientInfo?.gender}
                  options={genderOptions}
                  updateDropdown={(option: any) => {
                    setpatientInfo({ ...patientInfo, gender: option })
                  }}
                  errorMsg={formErrors?.gender}
                  placeholder="Gender"
                /> */}
                  <Select
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        border: "1px solid #ccd0e7",
                        borderRadius: "10px"
                      })
                    }}
                    className="country-select"
                    options={genders}
                    defaultValue={genders}
                    onChange={(option: any) => {
                      setpatientInfo({ ...patientInfo, gender: option?.value })
                    }}
                    placeholder="Gender"
                    value={genders.filter(
                      ({ label }: any) => label === patientInfo.gender
                    )}
                    isDisabled={isEditFlag}
                  />
                  <span className="error">{formErrors?.gender}</span>
                </div>

                <div className="col-md-4 col-lg-4 dob-input">
                  <label htmlFor="" className="label">
                    * Date of Birth
                  </label>
                  {/* <input type="date" id="dob" name="dob" value={patientInfo?.dob} required /> */}



                  <InputField
                    calendar={true}
                    value={patientInfo?.dob}
                    handleChange={(e) => {
                      const selectedDate = e.target.value;
                      const currentDate = new Date().toISOString().split('T')[0];

                      // Check if the selected date is a future date
                      if (selectedDate > currentDate) {
                        // If it's a future date, set the input value to the current date
                        e.target.value = currentDate;

                        // Calculate the age based on the current date
                        const age = moment(new Date()).diff(currentDate, 'years');

                        // Update the state with the current date and age
                        setpatientInfo({
                          ...patientInfo,
                          age: age,
                          dob: currentDate.toString(),
                          ageString: calculateAge(currentDate),
                        });
                      } else {
                        // If it's a valid date, calculate the age and update the state
                        const age = moment(new Date()).diff(selectedDate, 'years');
                        setpatientInfo({
                          ...patientInfo,
                          age: age,
                          dob: selectedDate.toString(),
                          ageString: calculateAge(selectedDate),
                        });
                      }

                      // Clear the error message for dob field
                      setFormErrors({
                        ...formErrors,
                        dob: '',
                      });

                      // Check if the year is not selected in the date field
                      if (selectedDate.length < 10) {
                        setFormErrors({
                          ...formErrors,
                          dob: 'Please select a valid date with a year!',
                        });
                      }
                    }}

                    readOnly={isEditFlag}
                    max={new Date().toISOString().split('T')[0]} // Set the max attribute to disable future dates
                    errorMsg={formErrors?.dob}
                  />


                </div>

                {userRole === MocUserRole.PATIENT ? <div className="col-md-4 col-lg-4 lt ">
                  <label htmlFor="" className="label">
                    Age
                  </label>
                  <div className="age-card disable"
                  >{patientInfo?.ageString}</div>
                </div> : <div className="col-md-4 col-lg-4 lt">
                  <label htmlFor="" className="label">
                    Age
                  </label>
                  <div className="age-card"
                  >{patientInfo?.ageString}</div>
                </div>}
              </div>

              <div className="patient-row">
                <div className="col-md-3 col-lg-3">
                  <label htmlFor="" className="label">
                    Blood Group
                  </label>
                  {/* <Dropdown
                  selected={patientInfo?.bloodGroup}
                  updateDropdown={(option: any) => {
                    setpatientInfo({ ...patientInfo, bloodGroup: option })
                  }}
                  placeholder="Select Blood Group"
                  options={bloodOptions}
                  errorMsg={formErrors?.bloodGroup}
                /> */}
                  <Select
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        border: "1px solid #ccd0e7",
                        borderRadius: "10px"
                      })
                    }}
                    className="country-select"
                    options={bloodgroups}
                    defaultValue={bloodgroups}
                    onChange={(option: any) => {
                      setpatientInfo({
                        ...patientInfo,
                        bloodGroup: option?.value,
                      })
                    }}
                    placeholder="Select Blood Group"
                    value={bloodgroups.filter(
                      ({ label }: any) => label === patientInfo.bloodGroup
                    )}
                    isDisabled={isEditFlag}
                  />
                  <span className="error">{formErrors?.bloodGroup}</span>
                </div>
                <div className="col-md-4 col-lg-4">
                  <label htmlFor="" className="label">
                    Education Level
                  </label>
                  {/* <Dropdown
                  options={educationLevelOptions}
                  selected={patientInfo?.additionalDetails?.educationLevel}
                  updateDropdown={(option: any) => {
                    const additionalDetails = {
                      ...patientInfo?.additionalDetails,
                      educationLevel: option,
                    }
                    setpatientInfo({
                      ...patientInfo,
                      additionalDetails,
                    })
                  }}
                  placeholder={"Education"}
                ></Dropdown> */}
                  <Select
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        border: "1px solid #ccd0e7",
                        borderRadius: "10px"
                      })
                    }}
                    className="country-select"
                    options={educationallevel}
                    defaultValue={educationallevel}
                    onChange={(option: any) => {
                      setpatientInfo({
                        ...patientInfo,
                        educationLevel: option?.value,
                      })
                    }}
                    placeholder="Education"
                    value={educationallevel.filter(
                      ({ label }: any) =>
                        label === patientInfo?.educationLevel
                    )}
                    isDisabled={isEditFlag}
                  />
                </div>

                <div className="col-md-4 col-lg-4">
                  <label htmlFor="" className="label">
                    Marital Status
                  </label>
                  {/* <Dropdown
                  options={maritalStatusOptions}
                  selected={patientInfo?.additionalDetails?.maritalStatus}
                  updateDropdown={(option: any) => {
                    const additionalDetails = {
                      ...patientInfo?.additionalDetails,
                      maritalStatus: option,
                    }
                    setpatientInfo({
                      ...patientInfo,
                      additionalDetails,
                    })
                  }}
                  placeholder="Select Marital Status"
                ></Dropdown> */}
                  <Select
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        border: "1px solid #ccd0e7",
                        borderRadius: "10px"
                      })
                    }}
                    className="country-select"
                    options={martialstatus}
                    defaultValue={martialstatus}
                    onChange={(option: any) => {
                      setpatientInfo({
                        ...patientInfo,
                        maritalStatus: option?.value,
                      })
                    }}
                    placeholder="Select Marital Status"
                    value={martialstatus.filter(
                      ({ label }: any) =>
                        label === patientInfo?.maritalStatus
                    )}
                    isDisabled={isEditFlag}
                  />
                </div>
              </div>
              <div className="patient-row" id="section3">
                <div className="col-md-3 col-lg-3">
                  <label htmlFor="" className="label">
                    Anniversary Date
                  </label>
                  <InputField
                    calendar={true}
                    placeholder="Anniversary Date"
                    value={patientInfo?.additionalDetails?.anniversaryDetails}
                    handleChange={(e) => {
                      const additionalDetails: any = {
                        ...patientInfo?.additionalDetails?.anniversaryDetails,
                        anniversaryDetails: e.target.value,
                      }

                      setpatientInfo({
                        ...patientInfo,
                        additionalDetails,
                      })
                    }}
                    max={moment(new Date()).format("YYYY-MM-DD")}
                    errorMsg={formErrors?.anniversaryDetails}
                    readOnly={isEditFlag}
                  />
                </div>
                <div className="col-md-2 col-lg-2 lt">
                  <label htmlFor="" className="label">
                    * Code
                  </label>

                  <div className="code-contry">
                    <Select
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          border: "1px solid #ccd0e7",
                          borderRadius: "10px"
                        })
                      }}
                      className="country-select"
                      defaultValue={patientInfo?.countryCode}
                      // defaultInputValue={
                      //   userRole !== MocUserRole.PATIENT ? "+91" : ""
                      // }
                      isDisabled={!phoneNumberEditPermittedRoles.includes(userRole) || isEditFlag}
                      placeholder={patientInfo?.countryCode}
                      isSearchable={true}
                      options={countriesList?.map((eachCountry) => {
                        return {
                          label: `${eachCountry?.dial_code}`,
                          value: eachCountry?.dial_code,
                        }
                      })}
                      onChange={(option: any) => {
                        setpatientInfo({
                          ...patientInfo,
                          countryCode: option?.value,
                        })
                      }}
                    />
                  </div>
                  {formErrors?.countryCode && (
                    <span className="code-error">{formErrors?.countryCode}</span>
                  )}
                </div>

                <div className="col-md-4 col-lg-4 contact_width">
                  <label htmlFor="" className="label">
                    * Contact Number
                  </label>
                  {isOtpVerified === true ? (
                    <InputField
                      placeholder="Contact Number"
                      value={patientInfo?.phoneNumber}
                      readOnly={!phoneNumberEditPermittedRoles.includes(userRole) || isEditFlag}
                      handleChange={(e) => {
                        const value = e.target.value
                        let res = ""
                        if (value) {
                          console.log("value", value)

                          value?.split("")?.forEach((ele: any) => {
                            let k = ele?.charCodeAt(0)
                            if (k >= 48 && k <= 57) {
                              res += ele
                            }
                          })
                        }
                        if (res) {
                          setpatientInfo({
                            ...patientInfo,
                            phoneNumber: res,
                          })
                        } else {
                          setpatientInfo({
                            ...patientInfo,
                            phoneNumber: "",
                          })
                        }
                      }}
                      errorMsg={formErrors?.phoneNumber}
                    />
                  ) : (
                    <InputField
                      placeholder="Contact Number"
                      value={patientInfo?.phoneNumber}
                      readOnly={!phoneNumberEditPermittedRoles.includes(userRole) || isEditFlag}
                      handleChange={(e) => {
                        const value = e.target.value
                        let res = ""
                        if (value) {
                          console.log("value", value)
                          value?.split("")?.forEach((ele: any) => {
                            let k = ele?.charCodeAt(0)
                            if (k >= 48 && k <= 57) {
                              res += ele
                            }
                          })
                        }
                        if (res) {
                          setpatientInfo({
                            ...patientInfo,
                            phoneNumber: res,
                          })
                        } else {
                          setpatientInfo({
                            ...patientInfo,
                            phoneNumber: "",
                          })
                        }
                      }}
                      errorMsg={formErrors?.phoneNumber}
                    />
                  )}
                </div>
                {/* {((!patientId && userRole !== MocUserRole.PATIENT) ||
                  (userRole === MocUserRole.SYSTEM_ADMIN &&
                    patientInfo?.phoneNumber !== patientDetail?.phoneNumber)) && (
                    <div className="col-md-1 mt-4_otp">
                      <Button
                        type="primary"
                        disabled={
                          userRole === MocUserRole.SYSTEM_ADMIN && !isVerifyOtpPhoneAdmin ? false :
                            !isVerifyOtpPhone
                              ? false
                              : true
                        }
                        text={
                          isVerifyOtpPhone === false ? "Resend OTP" : "Send OTP"
                        }
                        onClick={(e) => handleSubmitPhone(e)}
                      />
                    </div>
                  )} */}
              </div>
              {/* {(!patientId || userRole === MocUserRole.SYSTEM_ADMIN) && (
                <div className="patient-row">
                  <div className="col-md-3 col-lg-3">
                    {isOtpVerified === true ? (
                      <InputField
                        placeholder="Enter OTP"
                        readOnly={
                          userRole === MocUserRole.SYSTEM_ADMIN && !isVerifyOtpPhoneAdmin ? false :
                            isVerifyOtpPhone
                        }
                        value={checkOtp}
                        handleChange={(e: any) => setCheckOTP(e.target.value)}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                    }}
                  >
                    {!patientId && isVerifyOtpPhone && (
                      <div className="tick-icon">
                        <IconButton style={{ width: "25px", height: "25px" }}>
                          <CheckIcon
                            style={{ width: "100%", height: "100%" }}
                            color="success"
                          />
                        </IconButton>
                      </div>
                    )}
                  </div>
                  <div className="col-md-2 col-lg-2 verify-btn-margin">
                    {isOtpVerified === true && checkOtp ? (
                      <div className="ml-15">
                        <Button
                          type="success"
                          text={"Verify OTP"}
                          disabled={
                            userRole === MocUserRole.SYSTEM_ADMIN && !isVerifyOtpPhoneAdmin ? false
                              : isVerifyOtpPhone
                          }
                          onClick={(e) => handleSubmitOtpAndPhone(e)}
                        />
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              )} */}
              <div className="patient-row" id="section10">
                <div className="col-md-4 col-lg-4">
                  <label htmlFor="" className="label">
                    Alternate Contact Number
                  </label>
                  <InputField
                    placeholder="Alternate Contact Number"
                    value={patientInfo?.alternatePhoneNumber}
                    handleChange={(e) => {
                      const value = e.target.value
                      let res = ""
                      value?.split("")?.forEach((ele: any) => {
                        let k = ele?.charCodeAt(0)
                        if (k >= 48 && k <= 57) {
                          res += ele
                        }
                      })
                      if (res?.length <= 10) {
                        setpatientInfo({
                          ...patientInfo,
                          alternatePhoneNumber: res,
                        })
                      }
                    }}
                    readOnly={isEditFlag}
                    errorMsg={formErrors?.alternatePhoneNumber}
                  />
                </div>
                <div className="col-md-4 col-lg-4 edit_">
                  <label htmlFor="" className="label">
                    Patient Tag
                  </label>
                  <Select
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        border: "1px solid #ccd0e7",
                        borderRadius: "10px"
                      })
                    }}
                    className="country-select"
                    options={tags}
                    defaultInputValue={patientInfo?.tags}
                    onFocus={() => setIsMenuOpen(true)}
                    onBlur={() => setIsMenuOpen(false)}
                    menuIsOpen={isMenuOpen}
                    onChange={(option: any) => {
                      setpatientInfo({
                        ...patientInfo,
                        tags: option,
                      })

                    }}
                    isMulti
                    value={patientInfo?.tags}
                    placeholder="Patient Tag"
                    // value={tags.filter(
                    //   ({ label }: any) =>
                    //     label === tags
                    // )}
                    isDisabled={isEditFlag}
                  />
                </div>
                <div className="col-md-4 col-lg-4 email_">
                  <label htmlFor="" className="label">
                    Email
                  </label>

                  <InputField
                    placeholder="Email"
                    value={patientInfo?.email}
                    handleChange={(e) =>
                      setpatientInfo({
                        ...patientInfo,
                        email: e.target.value,
                      })
                    }
                    readOnly={isEditFlag}
                    errorMsg={formErrors?.email}
                  />
                </div>
              </div>

              <div className="patient-row" id="section9">
                <div className="col-md-5 col-lg-5 alternatenumber">
                  <label htmlFor="" className="label">
                    Nationality
                  </label>
                  <InputField
                    placeholder="Nationality"
                    value={patientInfo?.nationality}
                    handleChange={(e) =>
                      setpatientInfo({
                        ...patientInfo,
                        nationality: e.target.value,
                      })
                    }
                    readOnly={isEditFlag}
                    errorMsg={formErrors?.nationality}
                  />
                </div>
                <div className="col-md-6 col-lg-6 email" >
                  <label htmlFor="" className="label">
                    Ethnicity:
                  </label>
                  {/* <Dropdown
                  options={ethnicityOptions}
                  selected={patientInfo?.additionalDetails?.ethnicity}
                    eDropdown={(option: any) => {
                    const additionalDetails = {
                      ...patientInfo?.additionalDetails,
                      ethnicity: option,
                    }
                    setpatientInfo({
                      ...patientInfo,
                      additionalDetails,
                    })
                  }}
                  placeholder="Ethnicity"
                ></Dropdown> */}
                  <Select
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        border: "1px solid #ccd0e7",
                        borderRadius: "10px"
                      })
                    }}
                    className="country-select"
                    options={ethinicity}
                    defaultValue={ethinicity}
                    onChange={(option: any) => {
                      setpatientInfo({
                        ...patientInfo,
                        ethnicity: option?.value,
                      })
                    }}
                    placeholder="Ethnicity"
                    value={ethinicity.filter(
                      ({ label }: any) =>
                        label === patientInfo?.ethnicity
                    )}
                    isDisabled={isEditFlag}
                  />
                </div>
              </div>

              <div className="patient-row" id="section4">
                <div className="col-md-4 col-lg-4">
                  <label htmlFor="" className="label">
                    Occupation:
                  </label>
                  {/* <Dropdown
                  options={occupationOptions}
                  selected={patientInfo?.additionalDetails?.occupation}
                  updateDropdown={(option: any) => {
                    const additionalDetails = {
                      ...patientInfo?.additionalDetails,
                      occupation: option,
                    }
                    setpatientInfo({
                      ...patientInfo,
                      additionalDetails,
                    })
                  }}
                  placeholder="Occupation"
                ></Dropdown> */}
                  <Select
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        border: "1px solid #ccd0e7",
                        borderRadius: "10px"
                      })
                    }}
                    className="country-select"
                    options={occupationoption}
                    defaultValue={occupationoption}
                    onChange={(option: any) => {
                      const additionalDetails = {
                        ...patientInfo?.additionalDetails,
                        occupation: option?.value,
                      }
                      setpatientInfo({
                        ...patientInfo,
                        additionalDetails,
                      })
                    }}
                    placeholder="Occupation"
                    value={occupationoption.filter(
                      ({ label }: any) =>
                        label === patientInfo?.additionalDetails?.occupation
                    )}
                    isDisabled={isEditFlag}
                  />
                </div>
                <div className="col-md-3 col-lg-3 annual_income">
                  <label htmlFor="" className="label">
                    Annual Income
                  </label>
                  <InputField
                    type="number"
                    handleChange={(e) =>
                      setpatientInfo({
                        ...patientInfo,
                        annualIncome: e.target.value,
                      })
                    }
                    readOnly={isEditFlag}
                    value={patientInfo?.annualIncome}
                    placeholder="Annual Income"
                  />
                </div>
                <div className="col-md-3 col-lg-3 category_width">
                  <label htmlFor="" className="label">
                    * Category
                  </label>
                  <Select
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        border: "1px solid #ccd0e7",
                        borderRadius: "10px"
                      })
                    }}
                    className="country-select"
                    options={categories}
                    defaultValue={categories}
                    onChange={(option: any) => {
                      const selectedCategory = option?.value;
                      const temp = { ...patientInfo };
                      delete temp["subCategory"]
                      temp["category"] = selectedCategory
                      setpatientInfo(temp)
                    }}
                    placeholder="Select Category"
                    value={categories?.filter(
                      (item: any) => item?.value == patientInfo?.category?.toUpperCase()
                    )}
                    isDisabled={isEditFlag}
                  />
                  <span className="error">{formErrors?.category}</span>
                </div>
              </div>
              {
                subcategories?.length > 0 && (
                  <div className="patient-row">
                    <div className="col-md-4 col-lg-4">
                      <label htmlFor="" className="label">
                        * {patientInfo?.category?.toUpperCase()?.split("_")?.join(" ")}
                      </label>
                      <Select
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            border: "1px solid #ccd0e7",
                            borderRadius: "10px"
                          })
                        }}
                        className="country-select"
                        classNamePrefix="country-select"
                        options={subcategories}
                        onChange={(option: any) => {
                          setpatientInfo({
                            ...patientInfo,
                            subCategory: option?.label
                          });
                        }}
                        placeholder={subcategories?.filter(
                          (item: any) => item.label === patientInfo?.subCategory
                        ).length > 0
                          ? `Select ${patientInfo?.category?.split("_")?.join(" ")}`
                          : patientInfo?.subCategory}
                        value={subcategories?.filter(
                          (item: any) => item.label === patientInfo?.subCategory
                        )}
                        isDisabled={isEditFlag}
                      />
                      <span className="error">{formErrors?.subCategory}</span>
                    </div>
                  </div>
                )
              }
            </div>

            <div className="patient-address-form" id="section5">
              <div className="patient-row">
                <div className="col-md-6 col-lg-6 address-field1">
                  <label htmlFor="" className="label">
                    Address 1
                  </label>
                  <InputField
                    placeholder="Address 1"
                    title={patientInfo?.addressInfo?.addressLine1}
                    value={patientInfo?.addressInfo?.addressLine1}
                    handleChange={(e) => {
                      const addressInfo = {
                        ...patientInfo?.addressInfo,
                        addressLine1: e.target.value,
                      }
                      setpatientInfo({
                        ...patientInfo,
                        addressInfo,
                      })
                    }}
                    readOnly={isEditFlag}
                    errorMsg={formErrors?.address1}
                  />
                </div>
                <div className="col-md-5 col-lg-5 email">
                  <label htmlFor="" className="label">
                    Address 2
                  </label>
                  <InputField
                    readOnly={isEditFlag}
                    title={patientInfo?.addressInfo?.addressLine2}
                    placeholder="Address 2"
                    value={patientInfo?.addressInfo?.addressLine2}
                    handleChange={(e) => {
                      const addressInfo = {
                        ...patientInfo?.addressInfo,
                        addressLine2: e.target.value,
                      }
                      setpatientInfo({
                        ...patientInfo,
                        addressInfo,
                      })
                    }}
                    errorMsg={formErrors?.address2}
                  />
                </div>
              </div>
              <div className="patient-row">
                <div className="col-md-6 col-lg-6 address-field1">
                  <label htmlFor="" className="label">
                    State
                  </label>
                  {/* <Dropdown
                  selected={patientInfo?.addressInfo?.state}
                  updateDropdown={(option: any) => {
                    newCityOption(option)

                    const addressInfo = {
                      ...patientInfo?.addressInfo,
                      state: option,
                    }
                    setpatientInfo({
                      ...patientInfo,
                      addressInfo,
                    })
                  }}
                  options={newState}
                  errorMsg={formErrors?.state}
                  placeholder="State"
                /> */}

                  {/* <Select
                  className="country-select"
                  options={states}
                  defaultValue={states}
                  onChange={(option: any) => {
                    newCityOption(option)

                    const addressInfo = {
                      ...patientInfo?.addressInfo,
                      state: option?.value,
                    }
                    setpatientInfo({
                      ...patientInfo,
                      addressInfo,
                    })
                  }}
                  placeholder="State"
                  value={states.filter(
                    ({ label }: any) =>
                      label === patientInfo?.addressInfo?.state
                  )}
                  isDisabled={isEditFlag}
                /> */}

                  <InputField
                    placeholder="State"
                    value={patientInfo?.addressInfo?.state}
                    handleChange={(e) => {
                      const addressInfo = {
                        ...patientInfo?.addressInfo,
                        state: e.target.value,
                      }
                      setpatientInfo({
                        ...patientInfo,
                        addressInfo,
                      })
                    }}
                    readOnly={isEditFlag}
                    errorMsg={formErrors?.state}
                  />
                  <span className="error">{formErrors?.state}</span>
                </div>
                <div className="col-md-5 col-lg-5 email">
                  <label htmlFor="" className="label">
                    District
                  </label>
                  <InputField
                    placeholder="District"
                    value={patientInfo?.addressInfo?.district}
                    handleChange={(e) => {
                      const addressInfo = {
                        ...patientInfo?.addressInfo,
                        district: e.target.value,
                      }
                      setpatientInfo({
                        ...patientInfo,
                        addressInfo,
                      })
                    }}
                    readOnly={isEditFlag}
                    errorMsg={formErrors?.district}
                  />
                </div>
              </div>
              <div className="patient-row">
                <div className="col-md-6 col-lg-6 address-field1">
                  <label htmlFor="" className="label">
                    Suburb
                  </label>
                  <InputField
                    placeholder="Suburb"
                    value={patientInfo?.addressInfo?.suburb}
                    handleChange={(e) => {
                      const addressInfo = {
                        ...patientInfo?.addressInfo,
                        suburb: e.target.value,
                      }
                      setpatientInfo({
                        ...patientInfo,
                        addressInfo,
                      })
                    }}
                    readOnly={isEditFlag}
                    errorMsg={formErrors?.suburb}
                  />
                </div>
                <div className="col-md-5 col-lg-5 email">
                  <label htmlFor="" className="label">
                    Pincode
                  </label>
                  <InputField
                    placeholder="Pincode"
                    value={patientInfo?.addressInfo?.pincode}
                    handleChange={(e) => {
                      const addressInfo = {
                        ...patientInfo?.addressInfo,
                        pincode: e.target.value,
                      }
                      setpatientInfo({
                        ...patientInfo,
                        addressInfo,
                      })
                    }}
                    errorMsg={formErrors?.pincode}
                    readOnly={isEditFlag}
                  />
                </div>
              </div>
              <div className="patient-row">
                <div className="col-md-6 col-lg-6 address-field1">
                  <label htmlFor="" className="label">
                    Country
                  </label>
                  {/* <Dropdown
                  selected={patientInfo?.addressInfo?.country}
                  updateDropdown={(option: any) => {
                    const addressInfo = {
                      ...patientInfo?.addressInfo,
                      country: option,
                    }
                    setpatientInfo({
                      ...patientInfo,
                      addressInfo,
                    })
                  }}
                  options={countryOptions}
                  errorMsg={formErrors?.country}
                  placeholder="Country"
                /> */}
                  <Select
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        border: "1px solid #ccd0e7",
                        borderRadius: "10px"
                      })
                    }}
                    className="country-select"
                    options={countries}
                    defaultValue={countries}
                    onChange={(option: any) => {
                      const addressInfo = {
                        ...patientInfo?.addressInfo,
                        country: option?.value,
                      }
                      setpatientInfo({
                        ...patientInfo,
                        addressInfo,
                      })
                    }}
                    placeholder="Country"
                    value={countries.filter(
                      ({ label }: any) =>
                        label === patientInfo?.addressInfo?.country
                    )}
                    isDisabled={isEditFlag}
                  />
                  <span className="error">{formErrors?.country}</span>
                </div>
              </div>
            </div>
            <div className="patient-address-form" id="section6">
              <div className="patient-row">
                <div className="col-md-6 col-lg-6 address-field1">
                  <label htmlFor="" className="label">
                    Referred By
                  </label>
                  <Select
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        border: "1px solid #ccd0e7",
                        borderRadius: "10px"
                      })
                    }}
                    className="country-select"
                    options={referredby}
                    defaultValue={referredby}
                    onChange={(option: any) => {
                      if (option === "Social Media") {
                        setpatientInfo({
                          ...patientInfo,
                          referredBy: { referredBy: option?.value },
                        })
                      } else {
                        setpatientInfo({
                          ...patientInfo,
                          referredBy: { referredBy: option?.value },
                          additionalDetails: { ...patientInfo?.additionalDetails, websites: "" },
                        })
                      }
                    }}
                    placeholder="Referred By"
                    value={referredby.filter(
                      ({ label }: any) => label === patientInfo?.referredBy?.referredBy
                    )}
                    isDisabled={isEditFlag}
                  />
                  <span className="error">{formErrors?.referredBy}</span>
                </div>
                {
                  patientInfo?.referredBy?.referredBy === "Doctor" &&
                  <div className="col-md-5 col-lg-5 email">
                    <label htmlFor="" className="label">
                      Doctor Name
                    </label>
                    <Select
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          border: "1px solid #ccd0e7",
                          borderRadius: "10px"
                        })
                      }}
                      className="country-select"
                      options={referalConsultantsOptions}
                      onChange={(option: any) => {
                        const referredBy = {
                          ...patientInfo?.referredBy,
                          doctorName: option?.label,
                          doctorContactNumber: "",
                          doctorSpeciality: "",
                          doctorNameOthers: ""
                        }
                        if (option?.label !== "Others") {
                          delete referredBy.doctorNameOthers
                        }
                        const foundObj: any = referalConsultants?.find((e: any) => e?.id === option?.value)
                        if (foundObj) {
                          referredBy["doctorContactNumber"] = foundObj?.phoneNumber ? foundObj?.phoneNumber : ""
                          referredBy["doctorSpeciality"] = foundObj?.specialization ? foundObj?.specialization : ""
                        }
                        setpatientInfo({
                          ...patientInfo,
                          referredBy,
                        })
                      }}
                      placeholder="Doctor Name"
                      value={referalConsultantsOptions.filter(
                        ({ label }: any) =>
                          label === patientInfo?.referredBy?.doctorName
                      )}
                      isDisabled={isEditFlag}

                    />
                  </div>
                }
                {
                  patientInfo?.referredBy?.referredBy === "PRO /Marketing" &&
                  <div className="col-md-6 col-lg-6 address-field1">
                    <label htmlFor="" className="label">
                      Name
                    </label>
                    <InputField
                      placeholder="Name"
                      value={patientInfo?.referredBy?.proMarketingName}
                      handleChange={(e) => {
                        const referredBy = {
                          ...patientInfo?.referredBy,
                          proMarketingName: e.target.value,
                        }
                        setpatientInfo({
                          ...patientInfo,
                          referredBy,
                        })
                      }}
                      errorMsg={formErrors?.referredBy?.proMarketingName}
                      readOnly={isEditFlag}
                    />
                  </div>
                }
                <div className="col-md-5 col-lg-5 email mt-3">
                  {
                    patientInfo?.referredBy?.referredBy === "Social Media" && (
                      <div className="mt-5_others">
                        <Select
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              border: "1px solid #ccd0e7",
                              borderRadius: "10px"
                            })
                          }}
                          className="country-select"
                          options={websites}
                          defaultValue={websites}
                          onChange={(option: any) => {
                            const additionalDetails = {
                              ...patientInfo?.additionalDetails,
                              websites: option?.value,
                            }
                            setpatientInfo({
                              ...patientInfo,
                              additionalDetails,
                            })
                          }}
                          placeholder="Websites"
                          value={websites.filter(
                            ({ label }: any) =>
                              label === patientInfo?.additionalDetails?.websites
                          )}
                          isDisabled={isEditFlag}

                        />
                      </div>
                    )
                  }
                  <div className="col-md-5 col-lg-5 marhin-top">
                    {
                      patientInfo?.referredBy?.referredBy === "Others" && (
                        <>
                          <label htmlFor="" className="label">
                            Others
                          </label>
                          <InputField
                            placeholder="Others"
                            // value={patientInfo?.referredByOthers}
                            // handleChange={(e) => {
                            //   console.log(e)
                            //   // const referredBy = {
                            //   //   ...patientInfo,
                            //   //  ,
                            //   // }
                            //   setpatientInfo({
                            //     ...patientInfo,
                            //     referredByOthers: e.target.value,
                            //   })
                            // }}
                            value={patientInfo?.referredBy?.refferedByOthers}

                            handleChange={(e) => {
                              const refferedBy_others = {
                                ...patientInfo,
                              }
                              refferedBy_others.referredBy["refferedByOthers"] =
                                e.target.value
                              setpatientInfo(refferedBy_others)
                            }}
                            errorMsg={formErrors?.referredByOthers}
                            readOnly={isEditFlag}
                          />
                        </>
                      )
                    }
                  </div>
                </div>
              </div>
              {
                patientInfo?.referredBy?.doctorName === "Others" &&
                <div className="patient-row">
                  <div className="col-md-6 col-lg-6 address-field1">
                  </div>
                  <div className="col-md-5 col-lg-5 email">
                    {/* <label htmlFor="" className="label">
                      Others
                    </label> */}
                    <InputField
                      placeholder="Name"
                      value={patientInfo?.referredBy?.doctorNameOthers}
                      handleChange={(e) => {
                        const referredBy = {
                          ...patientInfo?.referredBy,
                          doctorNameOthers: e.target.value,
                        }
                        setpatientInfo({
                          ...patientInfo,
                          referredBy,
                        })
                      }}
                      readOnly={isEditFlag}
                    />
                  </div>
                </div>
              }
              {
                patientInfo?.additionalDetails?.websites === "Others" && (
                  <div className="patient-row">
                    <div className="col-md-6 col-lg-6 address-field1">
                      <label htmlFor="" className="label">
                        Others
                      </label>
                      <InputField
                        placeholder="Others"
                        value={patientInfo?.additionalDetails?.websiteothers}
                        handleChange={(e) => {
                          const websites_others = {
                            ...patientInfo,
                          }
                          websites_others.additionalDetails["websiteothers"] =
                            e.target.value
                          setpatientInfo(websites_others)
                        }}
                        errorMsg={formErrors?.referredBy?.others}
                        readOnly={isEditFlag}
                      />
                    </div>
                  </div>
                )
              }
              <div className="patient-row">
                {
                  patientInfo?.referredBy?.referredBy === "Doctor" ? (
                    <div className="col-md-6 col-lg-6 address-field1">
                      <label htmlFor="" className="label">
                        Doctor Speciality
                      </label>
                      <InputField
                        placeholder="Speciality"
                        value={patientInfo?.referredBy.doctorSpeciality}
                        handleChange={(e) => {
                          const referredBy = {
                            ...patientInfo?.referredBy,
                            doctorSpeciality: e.target.value,
                          }
                          setpatientInfo({
                            ...patientInfo,
                            referredBy,
                          })
                        }}
                        errorMsg={formErrors?.referredBy?.doctorSpeciality}
                        readOnly={isEditFlag}
                      />
                    </div>
                  )
                    : null
                }
                {
                  patientInfo?.referredBy?.referredBy === "Doctor" && (
                    <div className="col-md-5 col-lg-5 email">
                      <label htmlFor="" className="label">
                        Doctor Contact Number
                      </label>
                      <InputField
                        placeholder="Contact No"
                        value={patientInfo?.referredBy?.doctorContactNumber}
                        handleChange={(e) => {
                          const value = e.target.value
                          let res = ""
                          value?.split("")?.forEach((ele: any) => {
                            let k = ele?.charCodeAt(0)
                            if (k >= 48 && k <= 57) {
                              res += ele
                            }
                          })
                          if (res?.length <= 10) {
                            const referredBy = {
                              ...patientInfo?.referredBy,
                              doctorContactNumber: res,
                            }
                            setpatientInfo({
                              ...patientInfo,
                              referredBy,
                            })
                          }
                        }}
                        errorMsg={formErrors?.referredBy?.doctorContactNumber}
                        readOnly={isEditFlag}
                      />
                    </div>
                  )
                }
              </div>
              {/* <div className="patient-row">
              {patientInfo?.referredBy?.referredBy === "Doctor" && (
               
              )}
            </div> */}
            </div>
            <div className="patient-address-form" id="section7">
              <div className="patient-row">
                <div className="col-md-6 col-lg-6 address-field1">
                  <label htmlFor="" className="label">
                    Responsible Person Name
                  </label>
                  <InputField
                    placeholder="Name"
                    value={patientInfo?.responsiblePersonName}
                    handleChange={(e) => {
                      setpatientInfo({
                        ...patientInfo,
                        responsiblePersonName: e.target.value,
                      })
                    }}
                    errorMsg={formErrors?.responsiblePersonName}
                    readOnly={isEditFlag}
                  />
                </div>
                <div className="col-md-5 col-lg-5 email">
                  <label htmlFor="" className="label">
                    Relation
                  </label>
                  <InputField
                    placeholder="Relation"
                    value={patientInfo?.responsiblePersonRelation}
                    handleChange={(e) => {
                      setpatientInfo({
                        ...patientInfo,
                        responsiblePersonRelation: e.target.value,
                      })
                    }}
                    errorMsg={formErrors?.responsiblePersonRelation}
                    readOnly={isEditFlag}
                  />
                </div>
              </div>
              <div className="patient-row">
                <div className="col-md-3 col-lg-3">
                  <label htmlFor="" className="label">
                    Contact Detail.
                  </label>
                  <InputField
                    placeholder="Contact Detail"
                    value={patientInfo?.responsiblePersonPhoneNumber}
                    handleChange={(e) => {
                      setpatientInfo({
                        ...patientInfo,
                        responsiblePersonPhoneNumber: e.target.value,
                      })
                    }}
                    type="number"
                    errorMsg={formErrors?.responsiblePersonPhoneNumber}
                    readOnly={isEditFlag}
                  />
                </div>
                <div className="col-md-3 col-lg-3">
                  <label htmlFor="" className="label">
                    * Primary Consultant
                  </label>
                  {/* <InputField
                  placeholder="Primary Consultant"
                  value={patientInfo?.primaryConsultantName}
                  handleChange={(e) => {
                    setpatientInfo({
                      ...patientInfo,
                      primaryConsultantName: e.target.value,
                    })
                  }}
                  errorMsg={formErrors?.primaryConsultant}
                  readOnly={isEditFlag}
                /> */}
                  <Select
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        border: "1px solid #ccd0e7",
                        borderRadius: "10px"
                      })
                    }}
                    className="country-select"
                    options={consultantDetails?.map((each: any) => ({
                      label: each?.name,
                      value: each?.id
                    }))}
                    onChange={(option: any) => {
                      setpatientInfo({
                        ...patientInfo,
                        primaryConsultantName: option?.label,
                        primaryConsultantId: option?.value
                      })
                    }}
                    defaultInputValue={patientInfo?.primaryConsultantName}
                    isDisabled={isEditFlag}
                    value={consultantDetails?.map((each: any) => {
                      return { label: each?.name, value: each?.id }
                    })?.filter(({ label }: any) => {
                      return label === patientInfo?.primaryConsultantName
                    })}
                    placeholder="Primary Consultant"
                  />
                  <span className="error">{formErrors?.primaryConsultantName}</span>
                </div>
                <div className="col-md-4 col-lg-4 prefered">
                  <label htmlFor="" className="label">
                    Preferred Language for Communication
                  </label>
                  {/* <Dropdown
                  selected={patientInfo?.additionalDetails?.languagePreferences}
                  options={languageOptions}
                  updateDropdown={(option: any) => {
                    const additionalDetails = {
                      ...patientInfo?.additionalDetails,
                      languagePreferences: option,
                    }
                    setpatientInfo({
                      ...patientInfo,
                      additionalDetails,
                    })
                  }}
                  placeholder="Select Preferred Language"
                  errorMsg={formErrors?.languagePreferences}
                /> */}
                  <Select
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        border: "1px solid #ccd0e7",
                        borderRadius: "10px"
                      })
                    }}
                    className="country-select"
                    options={languages}
                    defaultValue={languages}
                    onChange={(option: any) => {
                      const additionalDetails = {
                        ...patientInfo?.additionalDetails,
                        languagePreferences: option?.value,
                      }
                      setpatientInfo({
                        ...patientInfo,
                        additionalDetails,
                      })
                    }}
                    isDisabled={isEditFlag}
                    placeholder="Select Preferred Language"
                    value={languages.filter(
                      ({ label }: any) =>
                        label ===
                        patientInfo?.additionalDetails?.languagePreferences
                    )}
                  />
                  <span className="error">{formErrors?.languagePreferences}</span>
                </div>
              </div>
            </div>
            <div className="patient-address-form" id="section8">
              <div className="patient-row">
                <div className="col-md-6 col-lg-6 address-field1">
                  <label htmlFor="" className="label">
                    Enter Proof Document Number
                  </label>
                  <InputField
                    placeholder="Enter ID Proof Number"
                    value={patientInfo?.governmentIdNo}
                    handleChange={(e) => {
                      const value = e.target.value
                      let res = ""
                      value.split("").forEach((ele) => {
                        let k = ele.charCodeAt(0)
                        if (
                          (k >= 65 && k <= 90) ||
                          (k >= 97 && k <= 122) ||
                          (k >= 48 && k <= 57)
                        ) {
                          res += ele
                        }
                      })
                      setpatientInfo({
                        ...patientInfo,
                        governmentIdNo: res,
                      })
                    }}
                    errorMsg={formErrors?.governmentIdNo}
                    readOnly={isEditFlag}
                  />
                </div>
                <div className="col-md-5 col-lg-5 email">
                  <label htmlFor="" className="label" aria-readonly={isEditFlag}>
                    Upload ID Proof
                  </label>
                  <InputField
                    placeholder="Enter Aadhar Number"
                    file={true}
                    filename={patientInfo?.governmentIdDocument?.name}
                    handleChange={(e: any) => {
                      uploadDocument(isEditFlag ? '' : e?.target?.files[0])
                    }}
                    errorMsg={formErrors?.governmentIdDocument}
                    accept="image/*,.pdf"
                    readOnly={isEditFlag}
                  />
                </div>
              </div>
            </div>
            <div className="patient-address-form" id="general-consent-container">
              <div className="patient-row">
                <div onClick={() => { if (!readOnly) setOpen(true) }} className="col-md-5 col-lg-5">
                  <p className="general-consent-heading">
                    {" "}
                    General Consent Form{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="patient-address-form">
              <div className="patient-row button-alignment">
                {!patientId && userRole !== MocUserRole.SYSTEM_ADMIN && (
                  <div>
                    <Button
                      text="Cancel"
                      type={"button"}
                      outline={true}
                      onClick={() => {
                        history.push("/patientList")
                      }}
                    />
                  </div>
                )}
                {userRole === MocUserRole.SYSTEM_ADMIN && (
                  <div>
                    <Button
                      text="Cancel"
                      type={"button"}
                      outline={true}
                      onClick={() => {
                        history.push({
                          pathname: "/managePatients",
                          state: {
                            centerId: centerID
                          }
                        })
                      }}
                    />
                  </div>
                )}
                <div>
                  {/* {userRole === MocUserRole.PATIENT && ( */}
                  <Button onClick={handleSubmit}
                    disabled={isEditFlag}
                    text={patientId ? "Save" : "Add"}
                    type={"submit"}
                  />
                  {/* )} */}
                </div>
              </div>
            </div>
            {
              <Modal size="xl" show={open} onHide={() => setOpen(false)}>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                  <Box sx={{ width: "100%", marginTop: "20px" }}>
                    {generalConsentTemplate && (
                      <div className="general-consent-container">
                        <SurveyComponent
                          css={defaultSurveyConfig.defaultSurveyCSS}
                          data={surveyData}
                          json={generalConsentTemplate}
                          onComplete={(survey: any) => {
                            console.log(survey.data)

                            /** Save to a database */
                            /** Add to a spreadsheet, etc.... */
                            handleFormComplete(survey?.data)
                          }}
                          hideDot={true}
                        />
                      </div>
                    )}
                  </Box>
                </Modal.Body>
              </Modal>
            }
          </div>
        </div>
      </div>
      {/* {previousState === "Manage-Patient" ? <><div className="patient-history-wrapper" style={{
        marginLeft: '50px',
      }}> {patientHistoryData?.slice(0, 5).map((pastAppointmentData: any) => (
        renderAccordionContentRow(
          <PatientHistoryCard
            data={pastAppointmentData}
            enableExpandedView={true}
          />,
          pastAppointmentData
        )
      ))}</div></> : <></>} */}

    </div >
  )
}

export default PatientEditForm
